module.exports = __webpack_public_path__ + "static/img/logo.9409920.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 1